export const DEFAULT_CONVENTIONS = [
  {
    slug: 'galaxycon_columbus',
    name: 'GalaxyCon Columbus',
    baseUrl: 'https://galaxycon.com/pages/galaxycon-columbus',
    parser: 'galaxycon_shopify',
    pages: {
      guests: 'https://galaxycon.com/pages/galaxycon-columbus-guests',
      autographs: 'https://galaxycon.com/pages/galaxycon-columbus-autographs',
      photoOps: 'https://galaxycon.com/pages/galaxycon-columbus-photo-ops',
      groupPhotoOps: 'https://galaxycon.com/pages/galaxycon-columbus-group-photo-ops',
      mailInAutographs: 'https://galaxycon.com/pages/galaxycon-columbus-mail-in-autographs',
    },
    events: [],
  },
  {
    slug: 'frontrowcardshow',
    name: 'Front Row Card Show',
    baseUrl: 'https://frontrowcardshow.com/collections',
    parser: 'frontrow_shopify_collections',
    pages: {
      collections: 'https://frontrowcardshow.com/collections.json',
    },
    events: [
      {
        name: 'Las Vegas',
        date_text: 'Jan 10-11, 2026',
        event_url: 'https://frontrowcardshow.com/collections/las-vegas',
        venue: 'Rio Hotel & Casino',
        address: '3700 W. Flamingo Road, Las Vegas, NV 89103',
        tableCount: 600,
        showHours: '11:00 AM - 5:00 PM',
        vipEntry: '10:00 AM',
        grading: ['Beckett', 'CBCS', 'CGC', 'JSA', 'PSA'],
        ticketUrl: 'https://www.showclix.com/event/front-row-card-show-las-vegas-2026-january-10-11',
      },
      {
        name: 'Pasadena',
        date_text: 'Jan 31-Feb 1, 2026',
        event_url: 'https://frontrowcardshow.com/collections/pasadena',
        venue: 'Pasadena Convention Center',
        address: '300 E. Green Street, Pasadena, CA 91101',
        tableCount: 540,
        showHours: '11:00 AM - 5:00 PM',
        vipEntry: '10:00 AM',
        grading: ['Beckett', 'CBCS', 'CGC', 'JSA'],
        ticketUrl: 'https://www.showclix.com/event/front-row-card-show-pasadena-2026-jan-31-feb-1',
      },
      {
        name: 'Phoenix',
        date_text: 'Dec 27-28, 2025',
        event_url: 'https://frontrowcardshow.com/collections/phoenix',
        venue: 'Renaissance Phoenix / Glendale Hotel',
        address: '9495 W. Entertainment Blvd., Glendale, AZ 85305',
        tableCount: 275,
        showHours: '11:00 AM - 5:00 PM',
        vipEntry: '10:00 AM',
        grading: ['CGC', 'JSA'],
        ticketUrl: 'https://www.showclix.com/event/front-row-card-show-phoenix-2025-dec-27-28',
      },
      {
        name: 'Portland',
        date_text: 'Feb 28-Mar 1, 2026',
        event_url: 'https://frontrowcardshow.com/collections/portland',
        venue: 'Oregon Convention Center',
        address: '777 NE Martin Luther King Jr Blvd, Portland, OR 97232',
        tableCount: 440,
        showHours: '11:00 AM - 5:00 PM',
        vipEntry: '10:00 AM',
        grading: ['Beckett', 'CBCS', 'CGC', 'JSA'],
        ticketUrl: 'https://www.showclix.com/event/front-row-card-show-portland-2026-Feb-28-mar-1',
      },
      {
        name: 'San Diego',
        date_text: 'Jan 17-18, 2026',
        event_url: 'https://frontrowcardshow.com/collections/san-diego',
        venue: 'Town & Country Resort',
        address: '500 Hotel Circle North, San Diego, CA 92108',
        tableCount: 425,
        showHours: '11:00 AM - 5:00 PM',
        vipEntry: '10:00 AM',
        grading: ['Beckett', 'CBCS', 'CGC', 'JSA'],
        ticketUrl: 'https://www.showclix.com/event/front-row-card-show-san-diego-2026-jan-17-18',
      },
      {
        name: 'Seattle / Tacoma',
        date_text: 'Jan 17-18, 2026',
        event_url: 'https://frontrowcardshow.com/collections/seattle',
        venue: 'Greater Tacoma Convention Center',
        address: '1500 Commerce Street, Tacoma, WA 98402',
        tableCount: 400,
        showHours: '11:00 AM - 5:00 PM',
        vipEntry: '10:00 AM',
        grading: ['Beckett', 'CBCS', 'CGC', 'JSA'],
        ticketUrl: 'https://www.showclix.com/event/front-row-card-show-seattle-tacoma-2026-jan',
      },
    ],
  },
];
